let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  if (!ctx) {
    try {
      ctx = new AC();
    } catch {
      return null;
    }
  }
  return ctx;
}

function tone(
  audio: AudioContext,
  destination: AudioNode,
  freq: number,
  start: number,
  duration: number,
  volume: number,
  type: OscillatorType = "triangle",
) {
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(volume, start + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  osc.connect(gain).connect(destination);
  osc.start(start);
  osc.stop(start + duration + 0.02);
}

export function playNotificationChime() {
  try {
    if (typeof window === "undefined") return;
    if (localStorage.getItem("notifications.soundMuted") === "true") return;
    const audio = getCtx();
    if (!audio) return;
    if (audio.state === "suspended") {
      // Will resume only after a user gesture; attempt and bail silently if blocked.
      void audio.resume().catch(() => {});
    }
    // Master gain so the overall chime is louder but still safe.
    const master = audio.createGain();
    master.gain.value = 0.9;
    master.connect(audio.destination);

    const now = audio.currentTime;
    // Three-note ascending arpeggio (A5 → E6 → A6) with sine sub-layer for body.
    tone(audio, master, 880, now, 0.18, 0.45, "triangle");
    tone(audio, master, 880, now, 0.18, 0.18, "sine");
    tone(audio, master, 1318.51, now + 0.13, 0.18, 0.45, "triangle");
    tone(audio, master, 1318.51, now + 0.13, 0.18, 0.18, "sine");
    tone(audio, master, 1760, now + 0.26, 0.32, 0.5, "triangle");
    tone(audio, master, 1760, now + 0.26, 0.32, 0.2, "sine");
  } catch {
    // Silently ignore — audio is non-essential.
  }
}